import { HOST } from "../helperData/ApiAddress";

export const host = HOST;

export const getProduct = `${HOST}/api/v1/feedback/items/:id/form/`;
export const saveRating = `${HOST}/api/v1/feedback/feedbacks/`;
export const produceLink = `${HOST}/api/v1/feedback/item-introductions/`;
export const produceContentLink = `${HOST}/api/v1/club/content-share-link/`;
export const itemContentsUrl = (itemId) =>
    `${HOST}/api/v1/club/contents/for-item/${itemId}/`;
export const getProductLink = `${HOST}/api/v1/feedback/item-introductions/:id/`;
export const sendOTP = `${HOST}/api/v1/feedback/item-introductions/:id/send-otp/`;
export const verifyOTP = `${HOST}/api/v1/feedback/item-introductions/:id/validate-otp/`;
export const sendFeedbackPost = `${HOST}/api/v1/feedback/offers/`;
export const GET_ALL_FOOD_ITEM_TYPES = `${HOST}/api/v1/menu/item-types/sale-cards/`;
export const GET_USED_DISCOUNT_CARD = `${HOST}/api/v1/club/used-discount-cards/user-panel/`;
export const CREATE_ORDER = `${HOST}/api/v1/menu/orders/`;
export const REGISTER_USER = `${HOST}/api/v1/menu/users/`;
